import React from "react";

import FacebookLogo from "./../assets/UserPanelAssets/img/icons/facebook-logo.svg";
import GoogleLogo from "./../assets/UserPanelAssets/img/icons/google-logo.svg";
import AppleLogo from "./../assets/UserPanelAssets/img/icons/apple-logo.svg";
import { SocialLoginFunc } from "./../config/commonfunctions/SocialLogin";

export default function SocialLogin() {
  return (
    <div className="mb-3">
      <div className="d-flex align-items-center justify-content-center flex-wrap">
        <div className="text-center me-2 flex-fill">
          <button
            onClick={() => SocialLoginFunc("facebook")}
            className="br-10 p-1 btn btn-outline-light border d-flex align-items-center justify-content-center w-100"
          >
            <img src={FacebookLogo} alt="Facebook" className="img-fluid m-1" />
          </button>
        </div>

        <div className="text-center me-2 flex-fill">
          <button
            onClick={() => SocialLoginFunc("google")}
            className="br-10 p-1 btn btn-outline-light border d-flex align-items-center justify-content-center  w-100"
          >
            <img src={GoogleLogo} alt="Google" className="img-fluid m-1" />
          </button>
        </div>
      </div>
    </div>
  );
}
